<div class="content-info">
    <div class="content-title">
        <h3 class="title">Users Management</h3>
        <div class="title-actions">
            <div class="form-group">
                <input type="text" [(ngModel)]="searchTerm" (input)="onSearch()" placeholder="Search Users..."
                    class="form-control" />
            </div>
            <button class="btn btnprimary" [routerLink]="['/users/create']">
                <i class="bi bi-plus-lg"></i> Create User
            </button>
        </div>
    </div>

    <div class="common-table">
        <div class="table-responsive" style="max-height: 65vh; overflow-y: auto; overflow-x: auto;">
            <table class="table">
                <thead>
                    <tr>
                        <th>Username</th>
                        <th>Email</th>
                        <th>Mobile</th>
                        <th>Name</th>
                        <th>Role</th>
                        <th>Status</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    @if (loading) {
                    <tr>
                        <td colspan="7" class="text-center">Loading users...</td>
                    </tr>
                    } @else if (!users.length) {
                    <tr>
                        <td colspan="7" class="text-center">No users found.</td>
                    </tr>
                    } @else {
                    @for (user of users; track user.id) {
                    <tr>
                        <td>{{ user.username }}</td>
                        <td>{{ user.email }}</td>
                        <td>{{ user.mobile }}</td>
                        <td>{{ user.name }}</td>
                        <td>{{ getRoleNames(user) }}</td>
                        <td>
                            <div class="form-check form-switch d-flex align-items-center justify-content-center gap-2">
                                <input class="form-check-input" type="checkbox" role="switch"
                                    id="statusSwitch-{{ user.id }}" [checked]="user.isActive"
                                    (change)="toggleStatus(user)" [class.bg-success]="user.isActive"
                                    [disabled]="!isAdmin()" />
                                <label class="form-check-label fw-semibold" [for]="'statusSwitch-' + user.id" [ngClass]="
                                    user.isActive ? 'text-success' : 'text-secondary'
                                ">
                                    {{ user.isActive ? "ACTIVE" : "INACTIVE" }}
                                </label>
                            </div>
                        </td>
                        <td>
                            <div class="td-actions-btn" *ngIf="isAdmin()">
                                <button class="btn btn-edit" [routerLink]="['/users/edit', user.id]">
                                    <i class="bi bi-pencil-square"></i>
                                </button>
                                <button class="btn btn-trash" (click)="deleteUser(user.id!)">
                                    <i class="bi bi-trash3"></i>
                                </button>
                            </div>
                        </td>
                    </tr>
                    }
                    }
                </tbody>
            </table>
        </div>

    </div>
</div>